import PropTypes from 'prop-types';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import AdditionalInfo from '../../components/AdditionalInfo';
import AccountNameForm from '../../components/Forms/AccountNameForm';
import { HeadingSubtitle } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import useAipFlow from '../../hooks/useAipFlow';
import { useMenu } from '../../hooks/useMenu';
import { selectApplication } from '../../store/selectors/applicationSelectors';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { APPLICANT_TYPES, APPLICATION_TYPE_STRING } from '../../util/constants';
import { secureAccountNameTitle } from '../../util/helpers/onboardingContentHelpers';

const SecureAccountName = ({ applicantType }) => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const Application = useSelector(selectApplication);
  const { ApplicationType } = Application;
  const { isAipFlow } = useAipFlow();
  const { DisplayBrokerCode, BrokerName } = useSelector(selectSettings);
  const formId = 'name_form';
  const [eventType, setEventType] = useState(null);

  return (
    <>
      <OnBoardingContainer
        activeMenu={activeMenu}
        activeItem={activeItem}
        previousPath={activeItem?.previousPath}
        formId={formId}
        setEventType={setEventType}
      >
        <Helmet>
          <title>
            {t('titleTagName', {
              brokerName: BrokerName,
            })}
          </title>
        </Helmet>
        <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
          {applicantType &&
            secureAccountNameTitle(applicantType, ApplicationType)}
        </HeadingSubtitle>

        <AccountNameForm
          nextPath={activeItem?.nextPath}
          path={activeItem?.path}
          applicantType={applicantType}
          formId={formId}
          setEventType={setEventType}
          eventType={eventType}
        />

        {applicantType === APPLICANT_TYPES.MAIN &&
          APPLICATION_TYPE_STRING[ApplicationType] !==
            APPLICATION_TYPE_STRING[3] && (
            <AdditionalInfo
              highlight={t('secureName.infoHighlight')}
              info={
                isAipFlow
                  ? t('metalstream.secureName.info', {
                      brokerCode: DisplayBrokerCode,
                    })
                  : t('secureName.info', {
                      brokerCode: DisplayBrokerCode,
                    })
              }
            />
          )}
      </OnBoardingContainer>
    </>
  );
};

SecureAccountName.propTypes = {
  applicantType: PropTypes.string,
};

export default SecureAccountName;
